import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import { connect } from 'react-redux';
import NativeTable from '../../../components/NativeTable/NativeTable';

import { Popover, PopoverBody, PopoverHeader, Alert, CustomInput, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import {
    Button,
    ButtonToolbar,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from "reactstrap";

import { loadProductCatalogIfNeeded } from '../../../actions/productCatalog';
import { getProductsRequest, deleteProductRequest, setCategoryId, createCategoryRequest, updateCategoryRequest, deleteCateogryRequest } from '../../../actions/products'
import { getMerchantId } from '../../../utils/merchant';
import Loader from '../../../components/Loader';
import Widget from '../../../components/Widget';
import s from './Categories.module.scss';
import { mockCategory, mockPrinters } from '../../../model/mockCategory';
import { IMAGE_PRESETS, processImageFileInput, revokeImagePreviewUrl } from '../../../utils/imageUtils';
import { toast } from 'react-toastify';
import { withTranslation } from '../../../i18n/LanguageContext';
import {
    loadCategoryOptions,
    createCategoryOption,
    updateCategoryOption,
    deleteCategoryOption,
    applyCategoryOptions,
    syncCategoryOptions,
} from '../../../actions/categoryOptions';

class Categories extends React.Component {
    
    static propTypes = {
        products: PropTypes.array,
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        products: []
    };

    state = {
        popovers: {},
        promoAlert: false,
        isAddModal: false,
        curCategory: mockCategory,
        picFile: null,
        tempPicture: "",
        categoryError: "",
        categoryOptions: [],
        optionDraft: { Name: '', Cost: '' },
        optionsBusy: false,
        optionsHelpOpen: false,
    };

    constructor() {
        super();
        this.apiFormatter = this.apiFormatter.bind(this);
        this.changeName = this.changeName.bind(this);
        this.changePrinter = this.changePrinter.bind(this);
        this.changeEnableQuickServeFlow = this.changeEnableQuickServeFlow.bind(this);
        this.changePicture = this.changePicture.bind(this);
    }

    loadProducts = () => {
        this.props.dispatch(loadProductCatalogIfNeeded());
    }

    componentDidMount() {
        this.loadProducts();
    }

    componentDidUpdate(prevProps) {
        const merchantId = getMerchantId(this.props.merchant);
        const prevMerchantId = getMerchantId(prevProps.merchant);
        if (merchantId !== prevMerchantId) {
            this.loadProducts();
        }
    }

    changeName(event) {
        var curCategory = this.state.curCategory;
        curCategory.Name = event.target.value;
        this.setState({ curCategory: curCategory });
    }

    changePrinter(event) {
        var curCategory = this.state.curCategory;
        curCategory.PrinterId = event.target.value;
        this.setState({ curCategory: curCategory });
    }

    changeEnableQuickServeFlow(event) {
        this.setState({
            curCategory: {
                ...this.state.curCategory,
                EnableQuickServeFlow: event.target.checked,
            },
        });
    }

    changeInternalOnly = (event) => {
        this.setState({
            curCategory: {
                ...this.state.curCategory,
                InternalOnly: event.target.checked,
            },
        });
    }

    async changePicture(event) {
        const input = event.target;
        const file = input.files && input.files[0];

        if (!file) {
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "" });
            return;
        }

        try {
            const result = await processImageFileInput(
                file,
                this.state.tempPicture,
                IMAGE_PRESETS.icon
            );
            this.setState({
                tempPicture: result.previewUrl,
                picFile: result.file,
                categoryError: "",
            });
        } catch (error) {
            console.error('[Categories] changePicture failed', error);
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "", categoryError: "" });
            toast.error(error.message || 'Could not use that photo. Try again with a smaller image.');
        } finally {
            input.value = '';
        }
    }

    showPromoAlert = () => {
        this.setState({promoAlert: true});
    }

    showAddModal = () => {
        this.setState({isAddModal: true});
    }

    hideAddModal = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        this.setState({
            isAddModal: false,
            categoryOptions: [],
            optionDraft: { Name: '', Cost: '' },
            optionsBusy: false,
        });
    }

    loadOptionsForCategory = async (categoryId) => {
        if (!categoryId) {
            this.setState({ categoryOptions: [] });
            return;
        }
        this.setState({ optionsBusy: true });
        try {
            const list = await loadCategoryOptions(categoryId);
            this.setState({ categoryOptions: list || [], optionsBusy: false });
        } catch (err) {
            this.setState({ optionsBusy: false });
            toast.error(err.message || 'Could not load category options');
        }
    }

    handleOptionDraftChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            optionDraft: { ...prev.optionDraft, [name]: value },
        }));
    }

    handleAddOption = async (e) => {
        e.preventDefault();
        const { curCategory, optionDraft } = this.state;
        if (!curCategory.CategoryId || !optionDraft.Name.trim()) return;
        this.setState({ optionsBusy: true });
        try {
            await createCategoryOption(curCategory.CategoryId, {
                Name: optionDraft.Name.trim(),
                Cost: Number(optionDraft.Cost) || 0,
            });
            this.setState({ optionDraft: { Name: '', Cost: '' } });
            await this.loadOptionsForCategory(curCategory.CategoryId);
            toast.success('Option template added');
        } catch (err) {
            this.setState({ optionsBusy: false });
            toast.error(err.message || 'Could not add option');
        }
    }

    handleUpdateOption = async (opt, patch) => {
        const { curCategory } = this.state;
        try {
            await updateCategoryOption(opt.CategoryOptionId, {
                Name: patch.Name != null ? patch.Name : opt.Name,
                Cost: patch.Cost != null ? Number(patch.Cost) : (opt.Cost != null ? Number(opt.Cost) : 0),
            });
            await this.loadOptionsForCategory(curCategory.CategoryId);
        } catch (err) {
            toast.error(err.message || 'Could not update option');
        }
    }

    handleDeleteOption = async (opt) => {
        const { curCategory } = this.state;
        if (!window.confirm(`Remove template "${opt.Name}"? Linked product options will be soft-deleted.`)) return;
        try {
            await deleteCategoryOption(opt.CategoryOptionId);
            await this.loadOptionsForCategory(curCategory.CategoryId);
            toast.success('Option template removed');
        } catch (err) {
            toast.error(err.message || 'Could not delete option');
        }
    }

    handleApplyOptions = async (force) => {
        const { curCategory } = this.state;
        if (!curCategory.CategoryId) return;
        const msg = force
            ? 'Force apply will re-add options even for products that opted out. Continue?'
            : 'Apply these option templates to all products in this category?';
        if (!window.confirm(msg)) return;
        this.setState({ optionsBusy: true });
        try {
            await applyCategoryOptions(curCategory.CategoryId, { force: !!force });
            this.setState({ optionsBusy: false });
        } catch (err) {
            this.setState({ optionsBusy: false });
            toast.error(err.message || 'Apply failed');
        }
    }

    handleSyncOptions = async () => {
        const { curCategory } = this.state;
        if (!curCategory.CategoryId) return;
        this.setState({ optionsBusy: true });
        try {
            await syncCategoryOptions(curCategory.CategoryId);
            this.setState({ optionsBusy: false });
        } catch (err) {
            this.setState({ optionsBusy: false });
            toast.error(err.message || 'Sync failed');
        }
    }

    toggleOptionsHelp = () => {
        this.setState((prev) => ({ optionsHelpOpen: !prev.optionsHelpOpen }));
    }

    imageFormatter(cell) {
        return (
            <img src={cell} alt="..." className={s.image} title="image"/>
        )
    }

    onClickTitle = (id) => {
        this.props.dispatch(setCategoryId(id));
    }

    getProductsByCategoryId = (id) => {
        let products = this.props.products.filter(function( p ) {
            return p.CategoryId == id;
        });

        return products;
    }
    
    itemsFormatter = (cell) => {
        if (cell) {
            let products = this.getProductsByCategoryId(cell);
            return products.length;
        } else {
            return ""
        }
    }

    titleFormatter =(cell, row) => {
        return cell ? (
            <Link to={'/admin/products/prod_list'} onClick={() => this.onClickTitle(row.CategoryId)}>
               {cell}
            </Link>
        ) : ""
    }

    editCategory = (id) => {
        if (id === 0) {
            this.setState({
                isAddModal: true,
                curCategory: { ...mockCategory },
                picFile: null,
                tempPicture: "",
                categoryError: "",
                categoryOptions: [],
                optionDraft: { Name: '', Cost: '' },
            });
            return;
        }

        const category = this.getCategoryById(id);
        this.setState({
            isAddModal: true,
            curCategory: category,
            picFile: null,
            tempPicture: "",
            categoryError: "",
            optionDraft: { Name: '', Cost: '' },
        });
        this.loadOptionsForCategory(id);
    }

    getCategoryById = (id) => {
        const {categories} = this.props;
        var data = categories.filter(function( c ) {
            return c.CategoryId == id;
        });

        var category = {... mockCategory};
        if (data.length > 0) {
            category = {
                ...data[0],
                EnableQuickServeFlow: !!(
                    data[0].EnableQuickServeFlow ?? data[0].enableQuickServeFlow
                ),
                InternalOnly: !!(data[0].InternalOnly ?? data[0].internalOnly),
            };
        } 
        return category;
    }

    deleteCategory = (id) => {
        this.props.dispatch(deleteCateogryRequest(id))
    }

    togglePopover = (id) => {
        let newState = {...this.state};
        if (!this.state.popovers[id]) {
            newState.popovers[id] = true;
        } else {
            newState.popovers[id] = !newState.popovers[id];
        }
        this.setState(newState);
    }

    apiFormatter = (cell, row) => {
        return (
            <ButtonToolbar className="">
                <button id={'popoverDelete_' + row.CategoryId} className="btn">
                    {this.props.isDeleting && this.props.idToDelete === row.CategoryId ? <Loader size={14}/> :
                        <div><i className="zmdi zmdi-delete"></i></div>
                    }
                </button>
                <button className="btn" onClick={()=> this.editCategory(row.CategoryId)}>
                    <div><i className="zmdi zmdi-edit"></i></div>
                </button>
                
                <Popover className="popover-danger" target={'popoverDelete_' + row.CategoryId} placement="top" isOpen={this.state.popovers[row.CategoryId]}
                         toggle={()=>{this.togglePopover(row.CategoryId)}}
                >
                    <PopoverHeader className="px-5">{this.props.t('common.confirm')}</PopoverHeader>
                    <PopoverBody className="px-5 d-flex justify-content-center">
                        <ButtonToolbar>
                            <Button color="success" size="xs" onClick={() => {this.deleteCategory(row.CategoryId)}}>
                                {this.props.t('common.yes')}
                            </Button>
                            <Button color="danger" size="xs" onClick={() => {this.togglePopover(row.CategoryId)}}>
                                {this.props.t('common.no')}
                            </Button>
                        </ButtonToolbar>
                    </PopoverBody>
                </Popover>
            </ButtonToolbar>
        )
    }

    renderSizePerPageDropDown = (props) => {
        const limits = [];
        props.sizePerPageList.forEach((limit) => {
            limits.push(<DropdownItem key={limit}
                                      onClick={() => props.changeSizePerPage(limit)}>{limit}</DropdownItem>);
        });

        return (
            <Dropdown isOpen={props.open} toggle={props.toggleDropDown}>
                <DropdownToggle color="default" caret>
                    {props.currSizePerPage}
                </DropdownToggle>
                <DropdownMenu>
                    {limits}
                </DropdownMenu>
            </Dropdown>
        );
    };

    createNewCategory = (e) => {
        e.preventDefault();

        const {curCategory, picFile} = this.state;

        var categoryError = "";
        if (curCategory.Name == "") {
            categoryError = "Please input name";
        } 

        if (categoryError == "") {
            if (curCategory.CategoryId == 0) {
                this.props.dispatch(createCategoryRequest({
                    curCategory,
                    picFile
                }));
            } else {
                this.props.dispatch(updateCategoryRequest({
                    curCategory,
                    picFile
                }));
            }
            this.setState({isAddModal: false});
        } else {
            this.setState({categoryError: categoryError});
        }
        //this.props.history.push('/app/ecommerce/management/create');
    }

    render() {
        const options = {
            sizePerPage: 10,
            paginationSize: 3,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
        };

        const {isAddModal, curCategory, tempPicture, categoryError} = this.state;

        return (
            <div className="category_list">
                <div className="tab_header">
                    <h1>
                        <span className="d-block">{this.props.t('productsTabs.categoriesTitle')}</span>
                    </h1>
                    <button type="button" className="btn" onClick={() => this.editCategory(0)}>{this.props.t('common.add')}</button>
                    {/* <form className="search_box">
                        <div className="form-group d-flex">
                            <div className="input-group-prepend">
                                <div className="input-group-text"><i className="zmdi zmdi-search"></i></div>
                            </div>
                            <input type="text" className="form-control" placeholder="Search"/>
                        </div>
                    </form> */}
                </div>
                <Widget>
                    <div className="order_list">
                        <NativeTable
                            data={this.props.categories}
                            searchFields={['Name']}
                            columns={[
                                { key: 'Picture', header: this.props.t('common.image'), render: (cell) => this.imageFormatter(cell) },
                                { key: 'Name', header: this.props.t('productsTabs.categoryName'), render: (cell, row) => this.titleFormatter(cell, row) },
                                { key: 'CategoryId', header: this.props.t('productsTabs.items'), render: (cell) => this.itemsFormatter(cell), hideMobile: true },
                                { key: 'printer', header: this.props.t('productsTabs.printer'), hideMobile: true },
                                { key: 'CategoryId', header: this.props.t('common.action'), render: (cell, row) => this.apiFormatter(cell, row) },
                            ]}
                        />
                    </div>

                    <Drawer anchor="right" open={isAddModal} onClose={this.hideAddModal}>
                        <div className="add_category_model add_expenses receipt_model px-0" 
                            id="add_expenses" tabIndex="-1" role="dialog" aria-labelledby="receipt_modelTitle" aria-modal="true">
                            <div className="modal-dialog modal-dialog-scrollable" role="document">
                                <div className="modal-content">
                                    <div className="modal-header px-0">
                                        <h2 className="col-10 mx-auto">{curCategory.CategoryId == 0 ? this.props.t('productsTabs.addCategory') : this.props.t('productsTabs.editCategory')}</h2>
                                    </div>
                                    <div className="row alert-container">
                                    {
                                        categoryError && (
                                            <Alert className="alert-sm" color="danger">
                                                {categoryError}
                                            </Alert>
                                        )
                                    }
                                    </div>
                                    <div className="modal-body p-0">
                                        <form>
                                            <div className="col-10 mx-auto form_container">
                                                <div className="row pb-4">
                                                    <div className="col-12 d-flex justify-content-center">
                                                        <div className="image-upload-compact">
                                                            <input id="img" type="file" onChange={this.changePicture} accept="image/*"/>
                                                            <label htmlFor="img" className="image-upload-label">
                                                                {(tempPicture || curCategory.Picture) ? (
                                                                    <>
                                                                        <img src={tempPicture || curCategory.Picture} alt="Category" className="image-upload-preview"/>
                                                                        <div className="image-upload-overlay">
                                                                            <i className="zmdi zmdi-camera"></i>
                                                                            <span>{this.props.t('productsTabs.changeImage')}</span>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <div className="image-upload-placeholder">
                                                                        <i className="zmdi zmdi-image-alt"></i>
                                                                        <span>{this.props.t('productsTabs.addIcon')}</span>
                                                                    </div>
                                                                )}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Category Name</label>
                                                    <input type="text" className="form-control" value={curCategory.Name} onChange={this.changeName}/>
                                                </div>

                                                <div className={`form-group ${s.quickServeToggle}`}>
                                                    <FormGroup check className={s.toggleRow}>
                                                        <CustomInput
                                                            type="switch"
                                                            id="enableQuickServeFlow"
                                                            label="Enable Send to Kitchen for this Category"
                                                            checked={!!curCategory.EnableQuickServeFlow}
                                                            onChange={this.changeEnableQuickServeFlow}
                                                        />
                                                    </FormGroup>
                                                    <p className={s.helpText}>
                                                        When enabled, walk-in Quick Serve checkout and kitchen send apply to items in this category.
                                                    </p>
                                                </div>

                                                <div className={`form-group ${s.quickServeToggle}`}>
                                                    <FormGroup check className={s.toggleRow}>
                                                        <CustomInput
                                                            type="switch"
                                                            id="internalOnlyCategory"
                                                            label="Internal item only"
                                                            checked={!!curCategory.InternalOnly}
                                                            onChange={this.changeInternalOnly}
                                                        />
                                                    </FormGroup>
                                                    <p className={s.helpText}>
                                                        Keep items in this category on POS and BistroAdmin only. They will not sync to connected online stores or other sales channels.
                                                    </p>
                                                </div>

                                                {curCategory.CategoryId > 0 && (
                                                    <div className={s.optionsSection}>
                                                        <div className={s.optionsHeader}>
                                                            <h3>Default options</h3>
                                                            <p className={s.helpText}>
                                                                Templates applied to products in this category. Products can remove an option to opt out.
                                                            </p>
                                                        </div>

                                                        {this.state.optionsBusy && (
                                                            <p className={s.helpText}>Working…</p>
                                                        )}

                                                        <div className={s.optionColumns} aria-hidden="true">
                                                            <span>Name</span>
                                                            <span>Price</span>
                                                            <span />
                                                        </div>

                                                        <ul className={s.optionsList}>
                                                            {(this.state.categoryOptions || []).map((opt) => (
                                                                <li key={opt.CategoryOptionId} className={s.optionRow}>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control ${s.optionInput}`}
                                                                        value={opt.Name || ''}
                                                                        onChange={(e) => {
                                                                            const name = e.target.value;
                                                                            this.setState((prev) => ({
                                                                                categoryOptions: prev.categoryOptions.map((o) =>
                                                                                    o.CategoryOptionId === opt.CategoryOptionId
                                                                                        ? { ...o, Name: name }
                                                                                        : o
                                                                                ),
                                                                            }));
                                                                        }}
                                                                        onBlur={(e) => this.handleUpdateOption(
                                                                            { ...opt, Name: e.target.value },
                                                                            { Name: e.target.value }
                                                                        )}
                                                                    />
                                                                    <div className={s.optionCostWrap}>
                                                                        <span className={s.optionCurrency}>$</span>
                                                                        <input
                                                                            type="number"
                                                                            className={`form-control ${s.optionInput} ${s.optionCost}`}
                                                                            step="0.01"
                                                                            min="0"
                                                                            value={opt.Cost != null ? opt.Cost : ''}
                                                                            placeholder="0"
                                                                            onChange={(e) => {
                                                                                const cost = e.target.value;
                                                                                this.setState((prev) => ({
                                                                                    categoryOptions: prev.categoryOptions.map((o) =>
                                                                                        o.CategoryOptionId === opt.CategoryOptionId
                                                                                            ? { ...o, Cost: cost }
                                                                                            : o
                                                                                    ),
                                                                                }));
                                                                            }}
                                                                            onBlur={(e) => this.handleUpdateOption(
                                                                                { ...opt, Cost: e.target.value },
                                                                                { Cost: e.target.value }
                                                                            )}
                                                                        />
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        className={s.optionRemoveBtn}
                                                                        onClick={() => this.handleDeleteOption(opt)}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>

                                                        <div className={s.optionDraft}>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${s.optionInput}`}
                                                                name="Name"
                                                                placeholder="Option name"
                                                                value={this.state.optionDraft.Name}
                                                                onChange={this.handleOptionDraftChange}
                                                            />
                                                            <div className={s.optionCostWrap}>
                                                                <span className={s.optionCurrency}>$</span>
                                                                <input
                                                                    type="number"
                                                                    className={`form-control ${s.optionInput} ${s.optionCost}`}
                                                                    name="Cost"
                                                                    placeholder="0"
                                                                    step="0.01"
                                                                    min="0"
                                                                    value={this.state.optionDraft.Cost}
                                                                    onChange={this.handleOptionDraftChange}
                                                                />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className={s.optionAddBtn}
                                                                disabled={this.state.optionsBusy || !this.state.optionDraft.Name.trim()}
                                                                onClick={this.handleAddOption}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>

                                                        <div className={s.optionsActionsHeader}>
                                                            <span className={s.optionsActionsLabel}>Apply options</span>
                                                            <button
                                                                type="button"
                                                                className={s.helpIconBtn}
                                                                onClick={this.toggleOptionsHelp}
                                                                aria-label="Explain apply, sync, and force apply"
                                                                title="What do these buttons do?"
                                                            >
                                                                <i className="zmdi zmdi-help-outline" />
                                                            </button>
                                                        </div>
                                                        <div className={s.optionsActions}>
                                                            <button
                                                                type="button"
                                                                className="btn"
                                                                disabled={this.state.optionsBusy || !(this.state.categoryOptions || []).length}
                                                                onClick={() => this.handleApplyOptions(false)}
                                                            >
                                                                Apply to all products
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn Cencel"
                                                                disabled={this.state.optionsBusy || !(this.state.categoryOptions || []).length}
                                                                onClick={this.handleSyncOptions}
                                                            >
                                                                Sync name/cost
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn Cencel"
                                                                disabled={this.state.optionsBusy || !(this.state.categoryOptions || []).length}
                                                                onClick={() => this.handleApplyOptions(true)}
                                                            >
                                                                Force apply
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>

                                            <div className="modal-footer">
                                                <div className="row no-gutters w-100">
                                                    <div className="col-6"> <button type="file" className="btn Cencel" onClick={(e) => this.hideAddModal(e)}>Cancel</button></div>
                                                    <div className="col-6"> <button type="file" className="btn" onClick={(e) => this.createNewCategory(e)}>{curCategory.CategoryId == 0 ? "Add": "Update"}</button></div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Drawer>

                    <Modal
                        isOpen={this.state.optionsHelpOpen}
                        toggle={this.toggleOptionsHelp}
                        zIndex={1400}
                        modalClassName={s.optionsHelpModal}
                        backdropClassName={s.optionsHelpBackdrop}
                    >
                        <ModalHeader toggle={this.toggleOptionsHelp}>Category option actions</ModalHeader>
                        <ModalBody>
                            <dl className={s.optionsHelpList}>
                                <dt>Apply to all products</dt>
                                <dd>
                                    Creates missing options from these templates on every product in the category.
                                    Skips products that already have the option, and skips products that removed it (opted out).
                                    Does not change name or price on options that already exist.
                                </dd>
                                <dt>Sync name/cost</dt>
                                <dd>
                                    Pushes the template’s current name and price onto product options that are still linked
                                    and not deleted. Does not create new options or restore opted-out products.
                                </dd>
                                <dt>Force apply</dt>
                                <dd>
                                    Clears opt-outs for these templates, then runs Apply so removed options are re-created.
                                    Still skips products that already have the option. Use Sync if you only need to update
                                    name or price on existing options.
                                </dd>
                            </dl>
                        </ModalBody>
                        <ModalFooter>
                            <button type="button" className="btn" onClick={this.toggleOptionsHelp}>Got it</button>
                        </ModalFooter>
                    </Modal>
                </Widget>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        products: state.products.data,
        categories: state.products.categories,
        merchant: state.auth.merchant,
        isReceiving: state.products.isReceiving,
        isDeleting: state.products.isDeleting,
        idToDelete: state.products.idToDelete,
        catalogError: state.products.error,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(Categories)));

